<template>
  <div class='menu wrap-content'>
    <!-- <Form ref="editForm" :rules="validateRules">
      <div style="display: flex">
        <FormItem label="菜单名：">
          <Input v-model="menuData.name" :autofocus="true" placeholder="请输入菜单名" style="width:200px"></Input>
        </FormItem>
        <FormItem label="name：">
          <Input v-model="menuData.url" :autofocus="true" placeholder="请输入name" style="width:200px"></Input>
        </FormItem>
        <FormItem label="菜单级别：">
          <Select v-model="menuData.type" style="width:200px" placeholder="请选择菜单级别">
            <Option value="">请选择</Option>
            <Option value="1">一级目录</Option>
            <Option value="1">二级目录</Option>
            <Option value="1">按钮</Option>
          </Select>
        </FormItem>
      </div>
      <div>
        <Button type="primary" @click="enterSearch()">查询</Button>
        <Button @click="refresh()">重置</Button>
      </div>
    </Form> -->
    <div style="border-bottom: 1px solid #dcdee2; padding-bottom: 10px; margin: 10px 0;">
      <Button type="primary" @click="handleDialogs">新增</Button>
    </div>
    <tree-grid
      :items='menuTreeData'
      :columns='columns'
      @on-row-click='rowClick'
      @on-selection-change='selectionClick'
      @on-sort-change='sortClick'
    ></tree-grid>
    <menu-edit :query="id" v-if="showDialogs" :showDialogs="showDialogs" :modelTitle="modelTitle" @showDialogs="handleShowDialogs" @refreshList="fetchAllMenu"></menu-edit>
  </div>
</template>
<script>
import TreeGrid from '@/components/elements/TreeGrid';
import menuEdit from '@/layout/dialogs/systemManage/menuEditByCustom';
export default {
  name: 'menu',
  components: {
    TreeGrid,
    menuEdit
  },
  data () {
    return {
      menuData: {},
      showDialogs: false,
      modelTitle: '',
      columns: [
        // 是否出现多选框
        // {
        //   type: 'selection',
        //   width: '50'
        // },
        {
          title: '菜单名',
          key: 'title',
          sortable: true,
          width: '150'
        },
        {
          title: 'name',
          key: 'url',
          width: '150'
        },
        {
          title: '图标标签',
          key: 'icon',
          width: '150'
        },
        // {
        //   title: '菜单级别',
        //   key: 'type',
        //   width: '150'
        // },
        // {
        //   title: '上级菜单',
        //   key: 'parentName',
        //   width: '150'
        // },
        {
          title: '操作',
          type: 'action',
          actions: [
            {
              type: 'primary',
              text: '修改'
            },
            {
              type: 'error',
              text: '删除'
            }
          ]
        }
      ],
      // 是否选中当前行 _checked
      // ,
      // _checked: true
      menuTreeData: [],
      id: ''
    };
  },
  created () {
    this.fetchAllMenu()
  },
  methods: {
    handleShowDialogs (value) {
      console.log(value, 'value')
      this.showDialogs = value
    },
    handleDialogs () {
      this.id = ''
      this.showDialogs = true
      this.modelTitle = '新增'
    },
    rowClick (data, index, event, text) {
      this.id = data.id
      if (text === '修改') {
        this.showDialogs = true
        this.modelTitle = '修改'
      } else if (text === '删除') {
        this.$Modal.confirm({
          title: '提示',
          content: '确认删除？',
          onOk: () => {
            const _self = this
            this.post(`/sys/menu/delete/${data.id}`).then(res => {
              this.$Message.success(res.msg)
              _self.fetchAllMenu()
            })
          }
        });
      }
    },
    selectionClick (arr) {
      console.log('选中数据id数组:' + arr)
    },
    sortClick (key, type) {
      console.log('排序字段:' + key)
      console.log('排序规则:' + type)
    },
    /**
     * 获取带层级的menu列表
     */
    fetchAllMenu () {
      console.log('fetchAllMenu')
      const _self = this;
      _self.menuTreeData = []
      _self.fetch('/sys/menu/menuTree').then(res => {
        let result = res.data;
        for (let menu of result) {
          let rootMenu = {
            id: menu.menuId,
            title: menu.name,
            url: menu.url,
            icon: menu.icon
          };
          if (menu.list && menu.list.length > 0) {
            // 默认不打开
            rootMenu.children = [];
            for (let child of menu.list) {
              let childMenu = {
                id: child.menuId,
                title: child.name,
                url: child.url,
                icon: child.icon
              }
              if (child.list && child.list.length > 0) {
                // 默认不打开
                childMenu.children = [];
                for (let lastChild of child.list) {
                  childMenu.children.push({
                    id: lastChild.menuId,
                    title: lastChild.name,
                    url: child.url,
                    icon: child.icon
                  })
                }
              }
              rootMenu.children.push(childMenu);
            }
          }
          this.menuTreeData.push(rootMenu);
        }
      });
    },
    reload () {
      const _self = this;
      console.log('reload')
      _self.showDialogs = false;
      _self.fetchAllMenu();
    }
    // ,
    // enterSearch () {
    //   const value = {
    //     query: this.menuData,
    //     page: {currPage: 1, pageSize: 200}
    //   }
    //   this.fetchAllMenu(value)
    // },
    // refresh () {
    //   this.menuData = {}
    //   this.fetchAllMenu()
    // }
  }
};
</script>



// WEBPACK FOOTER //
// src/layout/customPage/systemManage/menu.vue